import React from 'react';
import { Link } from 'react-router-dom';
import { LEGAL_CONTACT, POLICIES, POLICY_PATHS } from './policyContent';
import LegalPageShell from './LegalPageShell';

/** Combined page for Razorpay “Cancellation and Refunds” URL field. */
export default function CancellationAndRefundsPage() {
  const blocks = [POLICIES.cancellation, POLICIES.refund];

  return (
    <LegalPageShell
      title="Cancellation & Refund Policy"
      meta={`${LEGAL_CONTACT.company} — ${LEGAL_CONTACT.platform}`}
    >
      {blocks.map((policy) => (
        <div key={policy.title} style={{ marginBottom: '32px' }}>
          <h2 style={h2}>{policy.title}</h2>
          {policy.sections.map((sec) => (
            <section key={sec.heading} style={{ marginBottom: '16px' }}>
              <h3 style={h3}>{sec.heading}</h3>
              <p style={body}>{sec.body}</p>
            </section>
          ))}
        </div>
      ))}
      <p style={body}>
        See also:{' '}
        <Link to={POLICY_PATHS.cancellation} style={link}>Cancellation only</Link>
        {' · '}
        <Link to={POLICY_PATHS.refund} style={link}>Refund only</Link>
      </p>
    </LegalPageShell>
  );
}

const h2 = { color: '#c9a84c', fontSize: '18px', margin: '0 0 12px' };
const h3 = { color: '#c9a84c', fontSize: '14px', margin: '0 0 6px' };
const body = { color: '#b8c0cc', fontSize: '13px', margin: 0, lineHeight: 1.55, whiteSpace: 'pre-line' };
const link = { color: '#c9a84c' };
